<template>
  <v-list-item-icon :class="styleClassStr">
    <icon-application-cancel v-if="propsParam.applCd == '23'" />
    <icon-clock v-else-if="propsParam.applCd == '30'" />
    <icon-compensation v-else-if="propsParam.applCd == '42'" />
    <icon-overtime v-else-if="propsParam.applCd == '110'" />
    <icon-work-day v-else-if="propsParam.applCd == '301'" />

    <icon-paid-holiday v-else-if="propsParam.gntGubunCd == '1'" />
    <icon-substitute v-else-if="propsParam.gntGubunCd == '11'" />
    <!-- <icon-etc v-else-if="propsParam.gntGubunCd == '17'" /> -->
    <icon-business
      v-else-if="propsParam.gntGubunCd == '19' || propsParam.applCd == '201'"
    />
    <icon-book v-else-if="propsParam.gntGubunCd == '21'" />
    <icon-birth v-else-if="propsParam.gntGubunCd == '41'" />

    <icon-application v-else />
  </v-list-item-icon>
</template>

<script>
/* 신청서메뉴 아이콘 컴포넌트 */
// applCd   = '22',   '23',         '30',              '42',        '43',            '110',       '301'
// applCdNm = 근태신청,근태신청취소,출퇴근시간변경신청,보상휴가신청,보상휴가신청취소,연장근무신청,근무스케줄신청

import IconApplication from '@/assets/customIcon/IconApplication.vue'; // 근태신청
import IconApplicationCancel from '@/assets/customIcon/IconApplicationCancel.vue'; // 근태취소신청
import IconClock from '@/assets/customIcon/IconClock.vue'; // 출퇴근시간변경
import IconCompensation from '@/assets/customIcon/IconCompensation.vue'; // 보상휴가신청
import IconOvertime from '@/assets/customIcon/IconOvertime.vue'; // 연장근무
import IconWorkDay from '@/assets/customIcon/IconWorkDay.vue'; // 근무스케줄

import IconPaidHoliday from '@/assets/customIcon/IconPaidHoliday.vue'; // 연차휴가
import IconSubstitute from '@/assets/customIcon/IconSubstitute.vue'; // 대체휴가
// import IconEtc from '@/assets/customIcon/IconEtc.vue'; // 기타휴가신청
import IconBusiness from '@/assets/customIcon/IconBusiness.vue'; // 출장
import IconBook from '@/assets/customIcon/IconBook.vue'; // 교육훈련
import IconBirth from '@/assets/customIcon/IconBirth.vue'; // 배우자출산휴가
// import IconCertApplication from '@/assets/customIcon/IconCertApplication.vue'; // 제증명 신청

export default {
  props: {
    propsParam: Object,
    styleClassStr: {
      type: String,
      default: '',
    },
  },
  components: {
    IconApplication,
    IconApplicationCancel,
    IconClock,
    IconCompensation,
    IconOvertime,
    IconWorkDay,

    IconPaidHoliday,
    IconSubstitute,
    // IconEtc,
    IconBusiness,
    IconBook,
    IconBirth,
    // IconCertApplication,
  },
};
</script>
<style></style>
